"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@services/dynamic-translation/common");
var override_service_1 = require("@services/overrides/override-service");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    module.factory('prFieldsets', [
        '$q',
        '$http',
        '$routeParams',
        'rsEnvironment',
        'pr.API_ROUTES',
        'prSourceDataService',
        'prOverrideTrigger',
        function ($q, $http, $routeParams, env, API_ROUTES, sourceData, triggerOverrides) {
            var fieldsetCache = {};
            return {
                getMainSourceId: getMainSourceId,
                getMainFieldset: getMainFieldset,
                getFieldsetIdBySourceId: getFieldsetIdBySourceId,
                getCachedFieldsets: getCachedFieldsets,
                getFieldsetBySourceId: getFieldsetBySourceId,
                isInAnalyticsEngine: isInAnalyticsEngine,
                isWeightingEnabled: isWeightingEnabled
            };
            /**
             * Gets the the primary source to pull fieldset data from.
             * Used in various places, e.g. in the source dropdown menus,
             * the default source in new widgets, etc.
             * @return {string} source Id (surveyId or fieldsetId)
             */
            function getMainSourceId() {
                var mainSourceId = triggerOverrides({
                    event: override_service_1.OVERRIDE_EVENTS.SINGLE_FIELDSET,
                    sync: true
                });
                return mainSourceId || $routeParams.surveyId || '';
            }
            function getMainFieldset() {
                var mainSourceId = getMainSourceId();
                return getFieldsetBySourceId(mainSourceId);
            }
            function getFieldsetIdBySourceId(sourceId) {
                return $q.resolve().then(function () {
                    if (sourceData.getSourceType(sourceId) === sourceData.sourceTypes.FIELDSET) {
                        return sourceId;
                    }
                    return getFieldsetBySourceId(sourceId).then(function (fieldset) {
                        return fieldset.definition.fieldSetId;
                    });
                });
            }
            /**
             * Helper method to get fieldsets that are cached.
             * Better than using env.get() because env.get()
             * will perform a deep copy of all fieldsets.
             */
            function getCachedFieldsets() {
                if (lodash_1.default.isEmpty(fieldsetCache)) {
                    fieldsetCache = env.get(environment_1.ENV_VARS.FIELDSETS) || {};
                }
                return fieldsetCache;
            }
            function getFieldsetBySourceId(sourceId, language) {
                if (!sourceId) {
                    return $q.when();
                }
                var cacheKey = language ? sourceId + ":" + language : sourceId;
                if (fieldsetCache[cacheKey]) {
                    return $q.when(fieldsetCache[cacheKey]);
                }
                fieldsetCache = env.get(environment_1.ENV_VARS.FIELDSETS) || {};
                if (fieldsetCache[cacheKey]) {
                    return $q.when(fieldsetCache[cacheKey]);
                }
                var path = '';
                switch (sourceData.getSourceType(sourceId)) {
                    case sourceData.sourceTypes.SURVEY:
                        path = API_ROUTES.FSCS + sourceId + '/definition';
                        break;
                    case sourceData.sourceTypes.FIELDSET:
                        path = API_ROUTES.FIELDSETS + sourceId;
                        break;
                }
                var config = __assign(__assign({}, common_1.getLanguageHeaders(language)), { cache: true });
                return $http.get(path, config).then(function (response) {
                    return response.data;
                }).catch(function (error) {
                    console.error('Error getting a fieldset', error);
                    return {};
                }).then(function (fieldset) {
                    var cache = env.get(environment_1.ENV_VARS.FIELDSETS) || {};
                    cache[cacheKey] = fieldset;
                    fieldsetCache = cache;
                    env.set(environment_1.ENV_VARS.FIELDSETS, cache);
                    return cache[cacheKey];
                });
            }
            function isInAnalyticsEngine(sourceId) {
                if (!sourceId) {
                    return $q.when();
                }
                return getFieldsetBySourceId(sourceId).then(function (fieldset) {
                    var fieldSetId = fieldset.definition.fieldSetId;
                    return $http.get(API_ROUTES.IS_IN_ANALYTICS_ENGINE + fieldSetId, { cache: true })
                        .then(function (response) {
                        return response.data;
                    });
                });
            }
            function isWeightingEnabled(sourceId) {
                var configFlags = triggerOverrides({
                    event: override_service_1.OVERRIDE_EVENTS.CONFIG_FLAGS,
                    sync: true
                }) || {};
                if (configFlags.disableWeighting) {
                    return $q.when(false);
                }
                return getFieldsetBySourceId(sourceId).then(function (fs) {
                    return lodash_1.default.isObject(fs.definition.weights);
                });
            }
        }
    ]);
})(angular_1.module('qualtrics.pr'));
